export function isMessageDefinition(element) {
  return element && element.id && element.defaultMessage;
}
